import axios from 'axios';
export const WALLET_QUERY_STRING_PARAMETER = 'wallet';
export const proofsOf = (root, wallet) => axios
    .get(`${root}/legacy/proofs`, {
    params: {
        [WALLET_QUERY_STRING_PARAMETER]: wallet,
    },
})
    .then((r) => r.data);
//# sourceMappingURL=alchemy.js.map